import React from 'react';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { AboutLorena } from './components/AboutLorena';
import { Stats } from './components/Stats';
import { Vision } from './components/Vision';
import { Testimonials } from './components/Testimonials';
import { Timeline } from './components/Timeline';
import { Letter } from './components/Letter';
import { FormSection } from './components/FormSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="w-full min-h-screen bg-pearl-white font-montserrat text-soft-black overflow-x-hidden" data-id="element-0">
      <StickyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutLorena data-id="element-4" />
        <Stats data-id="element-5" />
        <Vision data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Timeline data-id="element-8" />
        <Letter data-id="element-9" />
        <FormSection data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <FloatingWhatsApp data-id="element-14" />
    </div>;
}